import script from "./WebpDetector.vue?vue&type=script&setup=true&lang=js"
export * from "./WebpDetector.vue?vue&type=script&setup=true&lang=js"

import "./WebpDetector.vue?vue&type=style&index=0&id=a14618c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a14618c2"]])

export default __exports__